<script setup>
import { computed, ref } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';
import PhoneNumberDialog from 'dashboard/components-next/message/PhoneNumberDialog.vue';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

// The phone dialog is a second root node, so the class callers pass (Fallback,
// Email) is bound onto the content span by hand instead of being inherited.
defineOptions({ inheritAttrs: false });

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content, false, false, true, true)
    .formattedMessage;
});

const activePhoneNumber = ref(null);

const handleClick = event => {
  const phoneElement = event.target.closest('[data-phone-number]');
  if (!phoneElement) return;

  activePhoneNumber.value = phoneElement.dataset.phoneNumber;
};
</script>

<template>
  <span
    v-dompurify-html="formattedContent"
    v-bind="$attrs"
    class="prose prose-bubble [&_.phone-number]:cursor-pointer [&_.phone-number]:underline [&_.phone-number]:decoration-dotted [&_.phone-number]:underline-offset-2"
    @click="handleClick"
  />
  <PhoneNumberDialog
    v-if="activePhoneNumber"
    :phone-number="activePhoneNumber"
    @close="activePhoneNumber = null"
  />
</template>
